import React from "react";
import PropTypes from "prop-types";
import { Tag } from "@td/ui";

const DEFAULT_COLOR = "#00498A";

const PracticeTeamItem = React.memo(({ value, style }) => (
  <Tag
    color={DEFAULT_COLOR}
    label={value}
    style={{
      minWidth: 0,
      padding: "0.125rem 0.625rem",
      ...style,
    }}
  />
));

PracticeTeamItem.propTypes = {
  value: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default PracticeTeamItem;
